import type { TourStep } from '../types';

export const creatingEngagementSteps: TourStep[] = [
  {
    target: '[data-tour="engagement-log-header"]',
    title: 'Engagement Letter Log',
    content:
      'This is where you create, track, and manage engagement letters — from initial draft through client signature to fully executed.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="engagement-log-new"]',
    title: 'Create a New Letter',
    content:
      'Click here to start. You\'ll search for the property address, select a template, and fill in client and fee details. The wizard pre-fills as much as possible from county records.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve seen this',
  },
  {
    target: '[data-tour="engagement-log-stats"]',
    title: 'Track Your Pipeline',
    content:
      'See how many letters are in each stage at a glance — total, drafts awaiting completion, pending client or appraiser signature, and fully executed.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="engagement-log-list"]',
    title: 'Manage Your Letters',
    content:
      'Click any row to open the editor where you can edit terms, send for e-signature, or download the signed PDF. Executed letters glow green and can\'t be deleted — they\'re retained per USPAP requirements.',
    placement: 'top',
    spotlightClicks: true,
  },
];
